<div class="card container">
  <div class="row justify-content-start" style="padding-top: 1rem">
    <div class="col-auto align-self-end">
      <h3 class="card-title" style="margin-bottom: 0">{{ titulo }}</h3>
    </div>
    <div class="col-auto align-self-start">
      <p-button
        label="Exportar"
        severity="primary"
        icon="pi pi-file"
        size="small"
        (onClick)="exportToExcel()"
      />
    </div>
  </div>
  <div style="padding-top: 50px">
    <p-table
      #dtCarTrip
      [value]="ltsCarTrips"
      [tableStyle]="{
        'min-width': '50rem',
        'margin-bottom': '50px'
      }"
      styleClass="p-datatable-striped p-datatable-sm"
      [paginator]="true"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 20]"
      [globalFilterFields]="['dri_name', 'dri_last_name', 'dri_phone']"
    >
      <ng-template pTemplate="caption">
        <div class="d-flex">
          <div class="col-4 align-items-left justify-content-end">
            <label for="buttondisplay" class="font-bold block px-2">
              Fecha Inicio
            </label>
            <p-calendar
              [(ngModel)]="dateStart"
              [showIcon]="true"
              inputId="buttondisplay"
              [showOnFocus]="false"
              dateFormat="dd-mm-yy"
              (onSelect)="getListCartrip()"
            />
          </div>
          <div class="col-4 align-items-left justify-content-end">
            <label for="buttondisplay" class="font-bold block px-2">
              Fecha Fin
            </label>
            <p-calendar
              [(ngModel)]="dateEnd"
              [showIcon]="true"
              inputId="buttondisplay"
              [showOnFocus]="false"
              (onSelect)="getListCartrip()"
              dateFormat="dd-mm-yy"
            />
          </div>
          <div class="col-4 align-items-left justify-content-center">
            @if (companyId === '0') {
              <label for="buttondisplay" class="font-bold block px-2">
              Ciudades
            </label>
            <br>
              <p-dropdown
                [options]="ltsStates"
                [(ngModel)]="selectedState"
                optionLabel="pd_name"
                optionValue="pd_code"
                placeholder="Selecciona un estado"
                class="m-3"
                (onChange)="onStateChange()"
              />
            }
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th id="tbcliente">Cliente</th>
          <th id="tbphone">Telefono</th>
          <th id="tbdaterequest">Fecha de solicitud</th>
          <th id="tborigin">Origen</th>
          <th id="tbdestination">Destino</th>
          <th id="tbdistance">Distancia</th>
          <th id="tbprice">Precio</th>
          <th id="tbtimewait">Tiempo Espera</th>
          <th id="tbplate">Vehiculo Asignado</th>
          <th id="tbdriver">Conductor</th>
          <th id="tbpgonedriver">Telefono conductor</th>
          <th id="tbstatustrip">Estado de la carrera</th>
          <th id="city">Ciudad</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-carTrip>
        <tr>
          <td>{{ carTrip.usr_name }} {{ carTrip.usr_last_name }}</td>
          <td>{{ carTrip.usr_phone }}</td>
          <td>
            <span class="no-break">{{
              carTrip.car_tri_date | date : "dd-MM-yyyy HH:mm:ss"
            }}</span>
          </td>
          <td>
            <span class="no-break">
              {{
                carTrip.add_name_origin
                  ? carTrip.add_name_origin
                  : "Sin información"
              }}
            </span>
          </td>
          <td>
            <span class="no-break">
              {{
                carTrip.add_name_destination
                  ? carTrip.add_name_destination
                  : "Sin información"
              }}
            </span>
          </td>
          <td>
            {{
              carTrip.car_tri_distance
                ? carTrip.car_tri_distance + " km"
                : "Sin información"
            }}
          </td>
          <td>
            <span class="no-break">
              {{
                carTrip.car_tri_price
                  ? "$ " + carTrip.car_tri_price.toFixed(2)
                  : "Sin información"
              }}
            </span>
          </td>
          <td>
            {{
              carTrip.car_tri_time_wait
                ? carTrip.car_tri_time_wait + " min"
                : "Sin información"
            }}
          </td>
          <td>
            {{
              carTrip.car_tri_plate ? carTrip.car_tri_plate : "Sin información"
            }}
          </td>
          <td>
            {{ carTrip.dri_name ? carTrip.dri_name : "Sin información" }}
            {{ carTrip.dri_last_name ? carTrip.dri_last_name : "" }}
          </td>
          <td>
            {{ carTrip.dri_phone ? carTrip.dri_phone : "Sin información" }}
          </td>
          <td>
            {{ carTrip.st_name ? carTrip.st_name : "Sin información" }}
          </td>
          <td>
            {{ carTrip.pd_name ? carTrip.pd_name : "Sin información" }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
